__turbopack_context__.v({
  "background": "PlpHero-module-scss-module__AEL7qG__background",
  "backgroundImage": "PlpHero-module-scss-module__AEL7qG__backgroundImage",
  "content": "PlpHero-module-scss-module__AEL7qG__content",
  "cta": "PlpHero-module-scss-module__AEL7qG__cta",
  "ctaContainer": "PlpHero-module-scss-module__AEL7qG__ctaContainer",
  "description": "PlpHero-module-scss-module__AEL7qG__description",
  "desktopImage": "PlpHero-module-scss-module__AEL7qG__desktopImage",
  "hero": "PlpHero-module-scss-module__AEL7qG__hero",
  "mobileImage": "PlpHero-module-scss-module__AEL7qG__mobileImage",
  "overlay": "PlpHero-module-scss-module__AEL7qG__overlay",
  "text": "PlpHero-module-scss-module__AEL7qG__text",
  "textOnly": "PlpHero-module-scss-module__AEL7qG__textOnly",
  "title": "PlpHero-module-scss-module__AEL7qG__title",
  "withImage": "PlpHero-module-scss-module__AEL7qG__withImage",
});
